import { CCard, CCardHeader } from "@coreui/react";
import React from "react";
const CustomerReports = () => {
  return (
    <div className="content">
      <CCard className="mb-4">
        <CCardHeader>Customer Reports</CCardHeader>
      </CCard>
    </div>
  );
};

export default CustomerReports;
